export const THEME_EDITOR = 'THEME_EDITOR';
export const BRAND_SETTINGS = 'BRAND_SETTINGS';